import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch } from 'react-redux';

import useFormFieldValue from '@gef-ui/form-core/hooks/state/useFormFieldValue';
import SubmitButton from '@gef-ui/form-material/SubmitButton';
import TextField from '@gef-ui/form-material/TextField';
import { getLabelMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import SingleNote from 'components/atoms/GefMui/SingleNote';
import { ComponentLoader } from 'components/index';
import { MaxLengths } from 'constants/forms';
import fetch from 'features/common/fetch';
import { addComment } from 'features/views/contactDetail/actions';
import { FIELDS } from 'features/views/contactDetail/form';

export const Notes = ({ contactId, comments, handleReload }) => {
	const dispatch = useDispatch();
	const hasNotes = !isNilOrEmpty(comments);
	const noteValue = useFormFieldValue({ fieldName: FIELDS.note });

	const handleSaveNote = useCallback(() => {
		dispatch(addComment(contactId));
	}, [dispatch, contactId]);

	return (
		<Grid size={12}>
			<ComponentLoader fetchStorePath={fetch.constants.urls.contactDetailComment} handleReload={handleReload}>
				<Paper sx={{ p: 3, borderRadius: 2 }}>
					<Stack spacing={5}>
						<Stack spacing={2}>
							<SectionHeader text={getLabelMessage('contactDetail:contactNotesSubheader')} />
							<Grid container>
								<Grid size={12}>
									<Grid container spacing={2}>
										<Grid size={12}>
											<TextField
												size="small"
												fieldName={FIELDS.note}
												label={getLabelMessage('contactDetail:contactNotesSubheader')}
												fullWidth
												multiline
												rows={4}
												slotProps={{
													htmlInput: {
														maxLength: MaxLengths.NOTE,
													},
												}}
											/>
										</Grid>
										<Grid size={12}>
											<Grid
												container
												sx={{
													justifyContent: 'flex-end',
												}}
											>
												<Grid size={3}>
													<SubmitButton
														variant="contained"
														fullWidth
														onClick={handleSaveNote}
														disabled={isNilOrEmpty(noteValue)}
														text={getLabelMessage('common:save')}
													/>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Stack>
						{hasNotes && <Divider />}
						<Stack spacing={5}>
							{hasNotes &&
								comments.map((item) => <SingleNote key={item?.id} id={item?.id} item={item} />)}
						</Stack>
					</Stack>
				</Paper>
			</ComponentLoader>
		</Grid>
	);
};

Notes.propTypes = {
	comments: PropTypes.array,
	contactId: PropTypes.string,
	fetchStorePath: PropTypes.string,
	handleReload: PropTypes.func,
};

export default Notes;
